var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5625 34.8125C28.5625 31.3607 31.3607 28.5625 34.8125 28.5625C38.2643 28.5625 41.0625 31.3607 41.0625 34.8125C41.0625 38.2643 38.2643 41.0625 34.8125 41.0625C31.3607 41.0625 28.5625 38.2643 28.5625 34.8125Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9375 49.1875C42.9375 45.7357 45.7357 42.9375 49.1875 42.9375C52.6392 42.9375 55.4375 45.7357 55.4375 49.1875C55.4375 52.6392 52.6392 55.4375 49.1875 55.4375C45.7357 55.4375 42.9375 52.6392 42.9375 49.1875Z",
    fill: "#466AEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5625 49.1875C28.5625 45.7357 31.3607 42.9375 34.8125 42.9375C38.2643 42.9375 41.0625 45.7357 41.0625 49.1875C41.0625 52.6392 38.2643 55.4375 34.8125 55.4375C31.3607 55.4375 28.5625 52.6392 28.5625 49.1875Z",
    fill: "#466AEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8422 29.6858C46.9329 29.8948 46.1093 30.3272 45.4388 30.923L44.1874 30.0408L42.7471 32.0842L44.0137 32.9771C43.7954 33.5483 43.6756 34.1669 43.6756 34.8125C43.6756 35.4581 43.7954 36.0768 44.0138 36.6481L42.7471 37.5408L44.1873 39.5842L45.4389 38.7021C46.1094 39.2979 46.9329 39.7301 47.8422 39.9393V41.0625H50.3422V39.9393C51.2514 39.7301 52.0749 39.2979 52.7454 38.7021L53.9971 39.5842L55.4373 37.5408L54.1707 36.6481C54.3891 36.0768 54.5089 35.4581 54.5089 34.8125C54.5089 34.1669 54.3891 33.5483 54.1708 32.9771L55.4374 32.0842L53.9971 30.0408L52.7456 30.923C52.0751 30.3272 51.2516 29.8948 50.3422 29.6858V28.5625H47.8422V29.6858ZM49.0922 32.0446C48.0612 32.0446 47.1689 32.5498 46.6526 33.2954C46.3492 33.7333 46.1756 34.2532 46.1756 34.8125C46.1756 35.3718 46.3492 35.8919 46.6526 36.3298C47.1691 37.0753 48.0612 37.5803 49.0922 37.5803C50.1232 37.5803 51.0153 37.0753 51.5318 36.3298C51.8352 35.8919 52.0089 35.3718 52.0089 34.8125C52.0089 34.2532 51.8353 33.7333 51.5319 33.2954C51.0154 32.5498 50.1233 32.0446 49.0922 32.0446Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.79738456d64937ecfa721d626ae79798.svg";
export { ForwardRef as ReactComponent };